'use client';
import React from 'react';

import BlockIcon from '@mui/icons-material/Block';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from '@mui/material';

import { useAppDispatch, useAppSelector } from '@/redux-store/hooks';
import { setShowRoleChangeNotificationAction } from '@/redux-store/slices/role-change-notification';
import { logout } from '@/redux-store/utils/logout';
import { t } from '@/utils/lang';

const UserRoleChangeNotification: React.FC = () => {
    const isShowRoleChangeNotification = useAppSelector(
        state => state.roleChangeNotification.isShowDialog
    );

    const dispatch = useAppDispatch();

    const setOpenDialog = (open: boolean) => {
        dispatch(setShowRoleChangeNotificationAction(open));
    };

    const handleUserLogout = async () => {
        logout();

        setOpenDialog(false);
    };

    return (
        <Dialog
            open={isShowRoleChangeNotification}
            maxWidth='xs'
            fullWidth
            disableEscapeKeyDown
        >
            <DialogContent
                sx={{ textAlign: 'center', position: 'relative', pt: 4 }}
            >
                <Box sx={{ mb: 2 }}>
                    <BlockIcon sx={{ fontSize: 60, color: 'primary.main' }} />
                </Box>

                <Typography variant='body1'>
                    {t(
                        'Quyền truy cập của bạn đã được cập nhật bởi quản trị viên. Vui lòng đăng nhập lại để áp dụng thay đổi.'
                    )}
                </Typography>

                <DialogActions sx={{ justifyContent: 'center', mt: 2 }}>
                    <Button variant='contained' onClick={handleUserLogout}>
                        {t('Đăng nhập lại')}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default UserRoleChangeNotification;
